<template>
  <modal name="modal-add-job" height="auto" :width="580"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head">
      <h4>ADD JOB</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="modal-body">
          <div class="form-group">
            <label for="name">Job Name <span class="text-danger">*</span></label>
            <input type="text" name="name" id="name" ref="inputTitle"
                   :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                   v-validate.disable="{ required: true }"
                   v-model="postData.name">
            <div class="invalid-feedback">{{ errors.first('name') }}</div>
          </div>
          <div class="form-group" :class="{'d-none': hideClientSelector}">
            <label for="client_id">Client <span class="text-danger">*</span></label>
            <select name="client_id" id="client_id"
                    :class="{'form-control': true, 'is-invalid': errors.has('client_id')}"
                    v-validate.disable="{ required: true }"
                    v-model="postData.client_id">
              <option value="">- Select -</option>
              <option v-for="client in CLIENTS" :key="client.id" :value="client.id">
                {{ client.name }}
              </option>
            </select>
            <div class="invalid-feedback">{{ errors.first('client_id') }}</div>
          </div>
          <div class="form-group">
            <label for="job_due_date">DUE DATE</label>
            <date-picker format="DD-MM-YYYY" value-type="YYYY-MM-DD" v-model="postData.due_date" id="job_due_date" :editable="false"
                         input-class="form-control" style="display: block;width: 100%;"></date-picker>
          </div>
        </div>
        <div class="modal-foot">
          <div class="btns btns-2">
            <beat-loader v-if="state == 'saving'"></beat-loader>
            <template v-else>
              <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
              <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
            </template>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>
<script>
  import { mapGetters } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import ServiceJob from '@/services/job'
  import DatePicker from 'vue2-datepicker';

  export default {
    components: {
      DatePicker,
      BeatLoader,
    },
    data () {
      return {
        state: '',
        hideClientSelector: false,
        postData: false,
      }
    },
    props: ['value', 'quote', 'clientId'],
    computed: {
      ...mapGetters(['CLIENTS'])
    },
    watch: {
      quote: 'init',
      clientId: 'init',
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          self.$modal.show('modal-add-job', {});
          setTimeout(() => {
            self.$refs.inputTitle.focus();
          }, 200);
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.hideClientSelector = typeof self.clientId != 'undefined' && self.clientId;
        self.resetForm();
        if(self.quote){
          self.postData.name = self.quote.name;
        }
        if(self.hideClientSelector){
          self.postData.client_id = self.clientId;
        }
      },
      resetForm () {
        let self = this;
        self.postData = {
          name: '',
          client_id: typeof self.clientId != 'undefined' && self.clientId?self.clientId:'',
          quote_id: typeof self.quote != 'undefined'?self.quote.id:'',
          due_date: ''
        };
      },
      closeModal () {
        this.$modal.hide('modal-add-job');
      },
      doCreate ( ) {
        let self = this;

        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              self.state = 'saving';

              if(!self.postData.quote_id){
                ServiceJob.create(self.postData, job => {
                  self.state = '';
                  self.$notify({
                    type: 'success',
                    text: 'Job <strong>' + job.name + '</strong> created'
                  });
                  self.resetForm();
                  self.$emit('job-created', job);
                  self.closeModal();
                }, () => {
                  self.state = '';
                });
              }else{
                self.$store.dispatch('ADD_QUOTE_JOB', self.postData)
                  .then(job => {
                    self.state = '';
                    self.$notify({
                      type: 'success',
                      text: 'New job is added successfully.'
                    });
                    self.resetForm();
                    self.$emit('job-created', job);
                    self.closeModal();
                  }, () => {
                    self.state = '';
                  })
                  .catch((error) => {
                    window.console.log(error);
                    self.state = '';
                  });
              }
            }
          });
      }
    }
  }
</script>
